import React from "react";
import { NavLink } from "react-router-dom";
import { LayoutGrid, Shield, User as UserIcon, Calculator } from "lucide-react";
import { useAuth, isAdminRole } from "../../context/AuthContext";

function Item({ to, icon: Icon, label, testId }) {
  return (
    <NavLink
      to={to}
      end
      data-testid={testId}
      className={({ isActive }) =>
        [
          "flex-1 flex flex-col items-center justify-center gap-0.5 py-2 text-[11px] transition-colors",
          isActive ? "text-foreground" : "text-muted-foreground",
        ].join(" ")
      }
    >
      <Icon size={20} strokeWidth={1.6} />
      <span>{label}</span>
    </NavLink>
  );
}

export function BottomNav() {
  const { user } = useAuth();
  return (
    <nav
      data-testid="bottom-nav"
      className="md:hidden fixed bottom-0 inset-x-0 h-16 border-t border-border/60 bg-background/95 backdrop-blur-lg flex items-center justify-around z-50"
    >
      <Item to="/" icon={LayoutGrid} label="Hub" testId="bottomnav-dashboard" />
      {isAdminRole(user?.role) && (
        <Item to="/admin" icon={Shield} label="Admin" testId="bottomnav-admin" />
      )}
      <Item to="/account" icon={UserIcon} label="Account" testId="bottomnav-account" />
    </nav>
  );
}
